import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { movieUrl } from '../../helpers';

// styles
import { Vector } from './Thumb.styles';

const Thumb = ({ poster, movieId, clickable, title }) => (
    <div>
        {clickable ? (
            <Link to={movieUrl(movieId, title)}>
                <Vector src={poster} alt='movie-thumb' />
            </Link>
        ) : (
            <Vector src={poster} alt='movie-thumb' />
        )}
    </div>
);

Thumb.propTypes = {
    poster: PropTypes.string,
    movieId: PropTypes.number,
    clickable: PropTypes.bool,
    title: PropTypes.string,
};

export default Thumb;